/**
 * 充值中心多入口来源（→ demo WX_FROM）
 * - 底导进入 = 根入口，无返回、显示品牌
 * - 页内「+」等入口 = 推入态，显示返回、隐藏品牌
 */
export const useWalletFrom = () =>
  useState<string | null>('walletFrom', () => null)

export const useWalletNav = () => {
  const localePath = useLocalePath()
  const router = useRouter()
  const walletFrom = useWalletFrom()

  /** 底导：根入口 */
  const openWalletRoot = () => {
    walletFrom.value = null
    return navigateTo(localePath('/wallet'))
  }

  /** 页内入口（余额胶囊 + 等）：推入态，带返回 */
  const openWalletPushed = (fromPath: string) => {
    walletFrom.value = fromPath
    return navigateTo(localePath('/wallet'))
  }

  const backFromWallet = () => {
    const from = walletFrom.value
    walletFrom.value = null
    if (from) return navigateTo(from)
    return router.back()
  }

  return {
    walletFrom,
    openWalletRoot,
    openWalletPushed,
    backFromWallet,
  }
}
